import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import SendOutlined from '@ant-design/icons/SendOutlined';
import KeyOutlined from '@ant-design/icons/KeyOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import SecurityScanOutlined from '@ant-design/icons/SecurityScanOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import ContactsOutlined from '@ant-design/icons/ContactsOutlined';
import FileProtectOutlined from '@ant-design/icons/FileProtectOutlined';
import FundProjectionScreenOutlined from '@ant-design/icons/FundProjectionScreenOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import HeartOutlined from '@ant-design/icons/HeartOutlined';
import MailOutlined from '@ant-design/icons/MailOutlined';
import CustomerServiceOutlined from '@ant-design/icons/CustomerServiceOutlined';
import ProjectOutlined from '@ant-design/icons/ProjectOutlined';
import ToolOutlined from '@ant-design/icons/ToolOutlined';
import LockOutlined from '@ant-design/icons/LockOutlined';
import ApiOutlined from '@ant-design/icons/ApiOutlined';
import IdcardOutlined from '@ant-design/icons/IdcardOutlined';

// ==============================|| MENU ITEMS - MAIN MODULES ||============================== //
// Grupo sem título (era "Módulos do Sistema" — redundante) e itens sem o prefixo "Módulo".

const main = {
  id: 'group-main',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard Core',
      type: 'item',
      url: '/dashboard',
      icon: DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'agenda-module',
      title: 'Agenda',
      type: 'item',
      url: '/agenda',
      icon: CalendarOutlined,
      permissionsPrefix: 'agenda.',
      breadcrumbs: false
    },
    {
      id: 'auth-module',
      title: 'Identidade',
      type: 'item',
      url: '/auth/usuarios',
      icon: SecurityScanOutlined,
      permissionsPrefix: 'auth.',
      breadcrumbs: false
    },
    {
      id: 'cadastros-module',
      title: 'Cadastros',
      type: 'item',
      url: '/cadastros/pessoas',
      icon: ContactsOutlined,
      permissionsPrefix: 'cadastros.',
      breadcrumbs: false
    },
    {
      id: 'cofre-module',
      title: 'Cofre de Senhas',
      type: 'item',
      url: '/cofre/credenciais',
      icon: LockOutlined,
      permissionsPrefix: 'cofre.',
      breadcrumbs: false
    },
    {
      id: 'financeiro-module',
      title: 'Financeiro',
      type: 'item',
      url: '/financeiro/lancamentos',
      icon: DollarOutlined,
      permissionsPrefix: 'financeiro.',
      breadcrumbs: false
    },
    {
      id: 'comercial-module',
      title: 'Comercial',
      type: 'item',
      url: '/comercial/dashboard',
      icon: FileProtectOutlined,
      permissionsPrefix: 'comercial.',
      breadcrumbs: false
    },
    {
      // Entra pela fila de leads: é a tela do dia a dia de quem vende.
      id: 'crm-module',
      title: 'CRM',
      type: 'item',
      url: '/crm/leads',
      icon: FundProjectionScreenOutlined,
      permissionsPrefix: 'crm.',
      breadcrumbs: false
    },
    {
      id: 'colaboradores-module',
      title: 'Colaboradores',
      type: 'item',
      url: '/colaboradores/colaboradores',
      icon: TeamOutlined,
      // Os prefixos do RH, um por um, e NÃO `colaboradores.` — porque `colaboradores.self.*` e
      // `colaboradores.equipe.*` também casariam com ele, e este item aponta para a lista de
      // colaboradores. Um prestador com a role Colaborador veria a porta do RH no menu e um "Sem
      // acesso" atrás dela. A porta dele é "Minha área", logo abaixo.
      permissionsPrefix: [
        'colaboradores.colaboradores.',
        'colaboradores.vinculos.',
        'colaboradores.mudancas.',
        'colaboradores.documentos.',
        'colaboradores.ausencias.',
        'colaboradores.notas-fiscais.',
        'colaboradores.reembolsos.',
        'colaboradores.avaliacoes.',
        'colaboradores.catalogos.',
        'colaboradores.remuneracao.'
      ],
      breadcrumbs: false
    },
    {
      // O portal de quem presta serviço. Entrada própria porque o endereço é próprio
      // (`/minha-area`, fora do grupo `/colaboradores`) e a permissão é de outra natureza: estas
      // telas mostram o PRÓPRIO dado, resolvido pelo usuário do token.
      id: 'minha-area-module',
      title: 'Minha área',
      type: 'item',
      url: '/minha-area',
      icon: IdcardOutlined,
      permissionsPrefix: 'colaboradores.self.',
      breadcrumbs: false
    },
    {
      id: 'cultura-module',
      title: 'Cultura',
      type: 'item',
      url: '/cultura/pesquisas-clima',
      icon: HeartOutlined,
      permissionsPrefix: 'cultura.',
      breadcrumbs: false
    },
    {
      id: 'helpdesk-module',
      title: 'Helpdesk',
      type: 'item',
      url: '/helpdesk',
      icon: CustomerServiceOutlined,
      permissionsPrefix: 'helpdesk.',
      breadcrumbs: false
    },
    {
      id: 'projetos-module',
      title: 'Projetos',
      type: 'item',
      url: '/projetos',
      icon: ProjectOutlined,
      permissionsPrefix: 'projetos.',
      breadcrumbs: false
    },
    {
      id: 'notificacoes-module',
      title: 'Notificações',
      type: 'item',
      url: '/notificacoes/envios',
      icon: MailOutlined,
      permissionsPrefix: 'notificacoes.',
      breadcrumbs: false
    },
    {
      id: 'admin-module',
      title: 'Administração',
      type: 'item',
      url: '/admin/jobs',
      icon: ToolOutlined,
      permissions: ['admin.jobs.view'],
      breadcrumbs: false
    },
    {
      // Entrada própria, e não `permissionsPrefix: 'admin.'` no item acima: aquele item aponta para
      // /admin/jobs, então alargar a permissão dele levaria quem não tem `admin.jobs.view` a uma
      // tela de "sem acesso". Quem só configura integrações precisa de uma porta que abra.
      id: 'admin-integracoes',
      title: 'Integrações',
      type: 'item',
      url: '/admin/integracoes',
      icon: ApiOutlined,
      permissions: ['admin.integracoes.manage'],
      breadcrumbs: false
    },
    {
      // Mesmo motivo da entrada acima: o item "Administração" aponta para /admin/jobs. Quem cuida
      // dos webhooks de saída (ou das contas de serviço) pode não ter `admin.jobs.view`, e sem uma
      // porta própria o menu não abriria nenhuma tela que essa pessoa pode ver.
      id: 'admin-webhooks',
      title: 'Webhooks de saída',
      type: 'item',
      url: '/admin/webhooks',
      icon: SendOutlined,
      permissions: ['admin.webhooks.manage'],
      breadcrumbs: false
    },
    {
      id: 'admin-servicos',
      title: 'Contas de serviço',
      type: 'item',
      url: '/admin/servicos',
      icon: KeyOutlined,
      permissions: ['auth.servicos.manage'],
      breadcrumbs: false
    }
  ]
};

export default main;
